import script from "./UserRates.vue?vue&type=script&setup=true&lang=js"
export * from "./UserRates.vue?vue&type=script&setup=true&lang=js"

import "./UserRates.vue?vue&type=style&index=0&id=36ecd47c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36ecd47c"]])

export default __exports__